<!--立项调整-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search
        :data="tableFilterList(tableHead)"
        @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
           <el-button type="text" size="mini" icon="el-icon-view" @click="view(scope.row)"></el-button>
          <el-button type="text" size="mini" icon="el-icon-edit" @click="edit(scope.row)"></el-button>
          <el-popover :ref="scope.row.billState" placement="top" width="180">
            <p>确定退回该立项调整单据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.billState].doClose()">取消</el-button>
              <!-- <el-button type="primary" size="mini" @click="audit(scope.row)">确定</el-button> -->
            </div>
            <el-button type="text" size="mini" icon="el-icon-back" slot="reference"></el-button>
          </el-popover>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="subDelete(scope.row.id)"
              >确定</el-button>
            </div>
            <el-button type="text" size="mini" icon="el-icon-delete" slot="reference"></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>

  import "@/components/EditDataTable"
  import DynamicSearch from "@/components/DynamicSearch"
  import DataTableMixin from "@/mixins/DataTableMixin"
  import { deleteProjectAdjustmentById,saveOrModifyProjectAdjustment } from "@/api/bill/ProjectAdjustment"
  import {tableSataus} from '@/views/bill/mixins/status'

  export default {
    name: "PartnerBudgetTask",
    components: {
      DynamicSearch,
    },
    mixins: [DataTableMixin,tableSataus],
    data() {
      return {
        tableHead: [
          // {
          //   prop: "code",
          //   label: "单据编号",
          //   query: {
          //     type: 'input'
          //   },
          // },
          {
            prop: "projectNumber",
            label: "项目号",
          },
          {
            prop: "name",
            label: "项目名",
            query: {
              type: 'input'
            },
          },
          // {
          //   prop: "projectTypeOri",
          //   label: "原立项类型",
          // },
          // {
          //   prop: "projectTypeNow",
          //   label: "现立项类型",
          // },
          // {
          //   prop: "sourceNumber",
          //   label: "来源单据号",
          // },
          // {
          //   prop: "operatorOriName",
          //   label: "原经营人",
          // },
          {
            label: '现经营人',
            prop: 'operatorNowName',
          },
          // {
          //   prop: "projectManagerNowName",
          //   label: "原项目负责人",
          // },
          {
            label: '现项目负责人',
            prop: 'projectManagerOriName',
          },
          // {
          //   prop: "costForecastOri",
          //   label: "原人工成本预算",
          // },
          {
            prop: "costBalance",
            label: "人工成本结余",
          },
          // {
          //   prop: "costForecastNow",
          //   label: "现人工成本预算",
          // },
          // {
          //   prop: "budgetOri",
          //   label: "原费用预算",
          // },
          {
            prop: "budgetBalance",
            label: "费用预算结余",
          },
          // {
          //   prop: "budgetOri",
          //   label: "现费用预算",
          // },
          // {
          //   prop: "costForecastOri",
          //   label: "原计划结项日期",
          // },

          {
            prop: "planCloseTimeNow",
            label: "现计划结项日期",
          },
          {
            prop: "remark",
            label: "备注",
          },
           {
          label: "状态",
          prop: "billState",
           formatter: (state) => {
              return this.statusName(state)
            }
        }
        ]
      }
    },
    created() {
      this.$nextTick(() => {
        this.dataTableInit()
      });
    },
    methods: {
      dataTableBeforeInit() {
        this._url = "/projectAdjustment"
        const params = { page: this.page, size: this.offset }
        this._params = Object.assign(params, this._query)
        return true
      },
        add() {
        this.$router.push({path: "adjust/form" ,query: {isEdit: 1}});
      },
      view(row) {
        this.$router.push({path: "adjust/form" ,query: { id: row.id,isEdit: 0}});
      },
       edit(row) {
        this.$router.push({path: "adjust/form" ,query: { id: row.id,isEdit: 1}})
      },
      audit(data) { // 审核
      console.log(data)
      data.projectDelivery = {id: data.id,billState: 3}
      this.updata(data);
      this.$refs[data.billState].doClose()
    },
      updata(data) {
      console.log(data)
      saveOrModifyProjectAdjustment(data).then(res => {
        console.log(res);
        if (res.code === 200) {
          this.$notify({
            title: "审核成功",
            type: "success",
            duration: 2500
          });
           this.dataTableInit();
        }
      });
    },
      subDelete(id) {
        deleteProjectAdjustmentById(id).then(res => {
          this.dataTableInit()
          this.$notify({
            title: "删除成功",
            type: "success",
            duration: 2500
          })
        })
      },
    }
  }
</script>

<style scoped lang="scss">
</style>
